<template>
    <div class="home-try-list-swiper">
        <div class="list">
            <div class="swiper-container swiper-components swiper-container-components">
                <div class="swiper-wrapper">
                    <div class="swiper-slide list-one" v-for="(item,index) in listData" :key="index">
                        <router-link :to="`/detail/` + item.id" href="#查看详情">
                            <div class="list-img" :class="{'list-img-full-cover': item.id === '1126', 'list-img-center': isService && item.try_stage === '第2期'  }">
                                <div class="cover-bg-img" v-if="item.id === '1126'">
                                    <img class="cover-bg-img-img" :src="item.try_pic" alt=""/>
                                </div>
                              <div class="is-member" v-if="item.is_member === '1'">
                                    <img class="is-member-img" src="@/assets/is-member.png" alt=""/>
                                </div>
                                <div class="img"><img :src="item.try_pic" alt=""/></div>
                                <p class="text">产品数量：{{item.total}} </p>
                                <div class="top-text" :class="{'top-text-service': isService}">{{ item.try_stage.replace(/ /g,"") }}</div>
                            </div>
                            <div class="list-title">
                                <p class="text">{{ item.try_title }}</p>
                                <p class="text-ti">活动开始时间：{{ item.date_begin.split(" ")[0] }}</p>
                            </div>
                        </router-link>
                        <div class="list-button">
                            <template v-if="isService">
                                <router-link :to="`/detail/` + item.id" href="#查看详情">
                                    <div class="button-detail1">
                                        查看详情>
                                    </div>
                                </router-link>
                            </template>
                            <template v-else>
                                <a :href="item.buy_url" target="_blank" v-if="item.buy_url">
                                    <div class="button-detail button-detail2">
                                        一键购买同款>
                                    </div>
                                </a>
                                <router-link :to="`/detail/` + item.id" href="#立即申请试用">
                                    <div class="button-detail1">
                                        立即申请试用>
                                    </div>
                                </router-link>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination swiper-pagination-components" v-if="listData.length > 3"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import "../../node_modules/swiper/dist/css/swiper.css";
    import Swiper from "swiper";

    export default {
        name: 'HomeTryListSwiper',
        props: ['listData', 'isService'],
        data() {
            return {
                swiperRecent:null,
            }
        },
        created() {

        },
        computed: {},
        mounted() {
            console.log('数据', this.listData.length)
            if (this.listData.length > 3) {
                this.$nextTick(() => {
                    this.initSwiper();
                });
            }

        },
        methods: {
            initSwiper() {
                if (this.swiperRecent) return;
                this.swiperRecent = new Swiper('.swiper-components', {
                    loop: false,
                    slidesPerView: 3,
                    spaceBetween: 5,
                    slidesPerGroup: 3,
                    speed: 600,
                    pagination: {
                        el: '.swiper-pagination-components',
                    },
                });
            },
        },
    }
</script>

<style lang="scss" scoped>

    .swiper-container-components {
        padding-bottom: 30px;
        margin-bottom: 30px;
    }

    .swiper-pagination-components {
        bottom: 0;
        text-align: center;
    }

    .list {
        .list-one {
            width: 32.75%;
            height: auto;
            margin-right: 0.875%;

            &:nth-child(3n) {
                margin-right: 0;
            }

            .list-img {
                position: relative;
                width: 100%;
                //height: 200px;
                padding: 26px 0 20px;
                background: url(~@/assets/img/page-home-container1-img-bg.png) no-repeat center center/100% 100%;

                .is-member {
                  position: absolute;
                  top: 20px;
                  left: 0;

                  .is-member-img {
                    height: 40px;
                  }
                }

                .img {
                    width: 150px;
                    height: 150px;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .top-text {
                    position: absolute;
                    top: 10px;
                    left: 0;
                    padding-left: 4px;
                    width: 50px;
                    height: 18px;
                    font-size: 10px;
                    color: #ffffff;
                    line-height: 18px;
                    background-color: #0976f1;
                    border-radius: 0 9px 9px 0;
                }

                .top-text-service {
                    background-color: #d71b13;
                }

                .text {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    font-size: 13px;
                    color: #335585;
                    line-height: 14px;
                }
            }

            // 图片满屏特殊处理
            .list-img-full-cover{
              .cover-bg-img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                .cover-bg-img-img {
                  width: 100%;
                  height: 100%;
                }
              }
              .img {
                img {
                  opacity: 0;
                }
              }
            }

            // 图片硬居中特殊处理
            .list-img-center{
                .img{
                    position: relative;
                    top: -30px;
                }
            }

            .list-title {
                position: relative;
                z-index: 2;
                margin: -20px auto 10px;
                padding: 1px 10px 10px;
                width: 90%;
                height: 50px;
                overflow: hidden;
                text-align: center;
                background: #ffffff;
                border-radius: 10px 0 10px 0;
                box-shadow: 2px 0 5px rgba(2, 42, 107, 0.18);

                &:hover {
                    .text {
                        -webkit-line-clamp: 2;
                    }
                }

                .text {
                    font-size: 14px;
                    font-weight: 600;
                    color: #000000;
                    line-height: 24px;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                }

                .text-ti {
                    font-size: 12px;
                    color: #757575;
                }
            }

            .list-time {
                margin: 0 auto;
                width: 86.2%;
                height: 21px;
                padding-left: 2.5%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: url(~@/assets/img/page-home-container1-time-bg.png) center center/cover no-repeat;
                border-radius: 10px;

                img {
                    width: 6.7%;
                    margin-right: 1.5%;
                }

                span {
                    font-size: 13px;
                    color: #ffffff;
                    width: 42%;
                    white-space: nowrap;
                    text-align: center;
                    line-height: 24px;

                    &:last-child {
                        margin-left: 4%;
                        width: 45%;
                    }
                }
            }

            .list-button {
                width: 95%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 15px auto 0;
                font-size: 13px;
                color: #595959;
                line-height: 14px;

                &.shiyong {
                    width: 95%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .button-detail {
                width: 103px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 10px;
                font-weight: bold;
                color: #000000;
                line-height: 21px;
                background: url(~@/assets/img/pc-btn1.png) center center/cover no-repeat;
                background-size: 100% 100%;
                box-shadow: 2px 0 5px rgba(2, 42, 107, 0.18);

                img {
                    width: 10px;
                    margin-left: 5px;
                }
            }

            .button-detail1 {
                width: 103px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 10px;
                font-weight: bold;
                color: #fff;
                line-height: 21px;
                background: url(~@/assets/img/pc-btn.png) center center/cover no-repeat;
                background-size: 100% 100%;
                box-shadow: 2px 0 5px rgba(2, 42, 107, 0.18);
            }
        }
    }
</style>
<style>
</style>
